export class AiPrompt {
  constructor(
    public id? :string,
    public name? :string,
    public model? :string,
    public client? :string,
    public maxLenght? :number,
    public prompt? :string,
  ) {}
}
